<script>
import { ref } from '@vue/composition-api'
import { useAppUpdate } from '@/util/service-worker'
import { RefreshCwIcon } from 'vue-feather-icons'
const ToastNotification = () => import(
  /* webpackChunkName: "ToastNotification.vue" */
  './ToastNotification.vue'
)

export default {
  components: {
    ToastNotification,
    RefreshCwIcon,
  },

  setup () {
    const {
      updateAvailable,
      applyUpdate,
    } = useAppUpdate()

    const loading = ref(false)

    return {
      updateAvailable,
      applyUpdate,
      loading,
    }
  },
}
</script>

<template>
  <ToastNotification
    v-if="updateAvailable"
  >
    <RefreshCwIcon class="mr-4" />
    A new version of the application is available.

    <template #actions>
      <BaseButton
        :loading="loading"
        class="px-4 py-2 hover:bg-gray-200 dark-hover:bg-gray-700"
        @click="loading = true;applyUpdate();"
      >
        Refresh
      </BaseButton>

      <BaseButton
        :disabled="loading"
        class="px-4 py-2 hover:bg-gray-200 dark-hover:bg-gray-700"
        @click="updateAvailable = false"
      >
        Dismiss
      </BaseButton>
    </template>
  </ToastNotification>
</template>
